module.exports = __webpack_public_path__ + "assets/img/pic_mold.c71c2ca9.png";